import { useQuery } from '@tanstack/react-query';
import { useNostr } from '@nostrify/react';
import { PLAYLIST_KIND, parsePlaylist, type Playlist } from '@/lib/musicTypes';

interface UsePlaylistsOptions {
  pubkey?: string;
  limit?: number;
}

export function usePlaylists(options: UsePlaylistsOptions = {}) {
  const { pubkey, limit = 50 } = options;
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['playlists', pubkey, limit],
    queryFn: async (c) => {
      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(5000)]);

      const filter: any = {
        kinds: [PLAYLIST_KIND],
        limit,
      };

      if (pubkey) {
        filter.authors = [pubkey];
      }

      const events = await nostr.query([filter], { signal });

      const playlists = events
        .map(parsePlaylist)
        .filter((playlist): playlist is Playlist => playlist !== null)
        .sort((a, b) => b.createdAt - a.createdAt);

      return playlists;
    },
  });
}
